import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import ContactForm from '../components/ContactForm';
import ContactHighlights from '../components/ContactHighlights';
import {contact} from '../data/contact';
import '../contact.css';

const details = [
  {icon: 'Mail', label: 'Email us', value: contact.email, href: `mailto:${contact.email}`},
  {icon: 'Phone', label: 'Call the studio', value: contact.phone, href: contact.phoneHref},
  {
    icon: 'MapPin',
    label: 'Visit us',
    value: `${contact.street}, ${contact.city}`,
    href: contact.mapUrl
  },
  {
    icon: 'Facebook',
    label: 'Social media page',
    value: contact.facebookLabel,
    href: contact.facebookUrl
  }
];

function Contact() {
  return (
    <section className="contact-page">
      <div className="contact-ambient contact-ambient-one" aria-hidden="true" />
      <div className="contact-ambient contact-ambient-two" aria-hidden="true" />
      <div className="contact-grid-lines" aria-hidden="true" />
      <motion.div
        className="contact-copy"
        initial={{opacity: 0, y: 35}}
        animate={{opacity: 1, y: 0}}
        transition={{duration: 0.8}}
      >
        <span className="eyebrow">
          <i aria-hidden="true" /> Start something great
        </span>
        <h1>
          Your next big idea <br />
          starts with a <em>hello.</em>
        </h1>
        <p className="contact-lead">
          Bring us the polished brief, the rough sketch, or the idea you cannot
          stop thinking about. We will help turn it into something remarkable.
        </p>
        <ContactHighlights />
        <div className="contact-details">
          {details.map((item) => (
            <a
              key={item.label}
              href={item.href}
              {...(item.href.startsWith('http')
                ? {target: '_blank', rel: 'noopener noreferrer'}
                : {})}
            >
              <span className="contact-detail-icon" aria-hidden="true">
                <SafeIcon name={item.icon} focusable="false" />
              </span>
              <span>
                <small>{item.label}</small>
                {item.value}
              </span>
              <SafeIcon
                name="ArrowUpRight"
                className="detail-arrow"
                aria-hidden="true"
                focusable="false"
              />
            </a>
          ))}
        </div>
      </motion.div>
      <ContactForm />
      <div className="contact-signature" aria-hidden="true">
        <span>Ideas</span> <i /> <span>Craft</span> <i /> <span>Impact</span>
      </div>
    </section>
  );
}

export default Contact;